import React from 'react';

import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { FLEXI_12_URL } from '../dashboard/Dashboard.sagas';
import ConfirmationButton from '../ui/confirmationButton/ConfirmationButton';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToDashboard: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: FLEXI_12_URL }
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

type TDashboardLink = PropsFromRedux & {
    children: React.ReactNode;
    className?: string;
    variant?: string;
    size?: string;
};

const DashboardLink = ({
    className,
    children,
    goToDashboard,
    variant,
    size
}: TDashboardLink) => {
    return (
        <ConfirmationButton
            className={className}
            onClick={goToDashboard}
            variant={variant}
            size={size}
        >
            {children}
        </ConfirmationButton>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DashboardLink);
